import { HTTP_GET, WebApiRequest } from "tools/webservice";
import { HolidayDto } from "interfaces/Mueller.Business.Models";
import { Ref } from "react";
import moment from "moment";

const getDateString = (date: Date) => moment(date).format("YYYY-MM-DD");

export const getHolidaysBetweenDates = (startDate: Date, endDate: Date, successCallback: (holidayList: HolidayDto[]) => void, mountedRef: Ref<boolean>) => WebApiRequest({
  method: HTTP_GET,
  endpoint: `/holidays/between/${getDateString(startDate)}/${getDateString(endDate)}`,
  successCallback,
  mountedRef,
});
